import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, withKeys as _withKeys, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17795884"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "panelRef",
  class: "nge-notif-panel"
}
const _hoisted_2 = { class: "nge-notif-topbar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-notif-title" }, "🔔 Notifications", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-notif-topbar-actions" }
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  key: 0,
  class: "nge-notif-confirm"
}
const _hoisted_7 = {
  key: 1,
  class: "nge-notif-tabs",
  role: "tablist"
}
const _hoisted_8 = ["aria-selected"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["aria-selected"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["aria-selected"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["aria-selected"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 2,
  class: "nge-notif-subtabs",
  role: "tablist"
}
const _hoisted_17 = ["aria-selected"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["aria-selected"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["aria-selected"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["aria-selected"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 3,
  class: "nge-notif-list"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "nge-notif-card-row" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "nge-notif-card-content" }
const _hoisted_30 = { class: "nge-notif-card-header" }
const _hoisted_31 = {
  key: 0,
  class: "nge-notif-unread-dot"
}
const _hoisted_32 = { class: "nge-notif-card-title" }
const _hoisted_33 = { class: "nge-notif-time" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "nge-notif-card-body nge-notif-card-body--preview" }
const _hoisted_36 = {
  key: 0,
  class: "nge-notif-reply-chip"
}
const _hoisted_37 = ["disabled", "onClick"]
const _hoisted_38 = {
  key: 4,
  class: "nge-notif-empty"
}
const _hoisted_39 = ["disabled", "onClick"]
const _hoisted_40 = ["onDblclick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["aria-label"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-notif-bracket nge-notif-bracket--tl",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-notif-bracket nge-notif-bracket--tr",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-notif-bracket nge-notif-bracket--bl",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-notif-bracket nge-notif-bracket--br",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-notif-detail-scan",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_48 = { class: "nge-notif-detail-topbar" }
const _hoisted_49 = { class: "nge-notif-detail-kicker" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-notif-detail-kicker-dot",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_51 = { class: "nge-notif-detail-kicker-label" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-notif-detail-kicker-sep",
  "aria-hidden": "true"
}, "/", -1 /* HOISTED */))
const _hoisted_53 = { class: "nge-notif-detail-time" }
const _hoisted_54 = { class: "nge-notif-detail-scroll" }
const _hoisted_55 = {
  key: 0,
  class: "nge-notif-detail-image"
}
const _hoisted_56 = ["src"]
const _hoisted_57 = {
  key: 0,
  class: "nge-notif-digest-stats",
  "aria-label": "What players did"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-notif-digest-stats-kicker" }, "Players made", -1 /* HOISTED */))
const _hoisted_59 = { class: "nge-notif-digest-stat" }
const _hoisted_60 = { class: "nge-notif-digest-stat-num" }
const _hoisted_61 = { class: "nge-notif-digest-stat-label" }
const _hoisted_62 = { class: "nge-notif-digest-stat" }
const _hoisted_63 = { class: "nge-notif-digest-stat-num" }
const _hoisted_64 = { class: "nge-notif-digest-stat-label" }
const _hoisted_65 = { class: "nge-notif-detail-text" }
const _hoisted_66 = { class: "nge-champs-head" }
const _hoisted_67 = ["src"]
const _hoisted_68 = {
  key: 1,
  class: "nge-champs-cup"
}
const _hoisted_69 = { class: "nge-champs-head-text" }
const _hoisted_70 = { class: "nge-champs-kicker" }
const _hoisted_71 = { class: "nge-champs-range" }
const _hoisted_72 = {
  key: 0,
  class: "nge-champs-dates"
}
const _hoisted_73 = { class: "nge-champs-intro" }
const _hoisted_74 = { class: "nge-champs-columns" }
const _hoisted_75 = { class: "nge-champs-section-head" }
const _hoisted_76 = { class: "nge-champs-section-label" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-champs-section-rule",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_78 = {
  key: 0,
  class: "nge-champs-section-count"
}
const _hoisted_79 = {
  key: 0,
  class: "nge-champs-empty"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-champs-empty-ring",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("span")
], -1 /* HOISTED */))
const _hoisted_81 = { class: "nge-champs-empty-text" }
const _hoisted_82 = { class: "nge-champs-empty-title" }
const _hoisted_83 = { class: "nge-champs-empty-sub" }
const _hoisted_84 = { class: "nge-champs-podium" }
const _hoisted_85 = ["role", "tabindex", "title", "onClick", "onKeydown"]
const _hoisted_86 = ["src"]
const _hoisted_87 = {
  key: 1,
  class: "nge-champs-medal",
  "aria-hidden": "true"
}
const _hoisted_88 = { class: "nge-champs-name" }
const _hoisted_89 = { class: "nge-champs-num" }
const _hoisted_90 = { class: "nge-champs-unit" }
const _hoisted_91 = { class: "nge-champs-plinth" }
const _hoisted_92 = {
  key: 0,
  class: "nge-champs-list"
}
const _hoisted_93 = ["role", "tabindex", "title", "onClick", "onKeydown"]
const _hoisted_94 = { class: "nge-champs-row-rank" }
const _hoisted_95 = { class: "nge-champs-row-name" }
const _hoisted_96 = { class: "nge-champs-row-num" }
const _hoisted_97 = { class: "nge-champs-row-unit" }
const _hoisted_98 = {
  key: 0,
  class: "nge-champs-outro"
}
const _hoisted_99 = { class: "nge-notif-detail-title" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-notif-detail-rule",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_101 = ["innerHTML"]
const _hoisted_102 = {
  key: 0,
  class: "nge-notif-help-solved",
  role: "status"
}
const _hoisted_103 = {
  key: 2,
  class: "nge-notif-reply"
}
const _hoisted_104 = {
  key: 0,
  class: "nge-rs-done",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-rs-corner nge-rs-corner--tl",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-rs-corner nge-rs-corner--br",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_107 = {
  class: "nge-rs-art",
  "aria-hidden": "true"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-rs-kicker" }, "Reply received", -1 /* HOISTED */))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-rs-text" }, "Thank you! The team has your reply.", -1 /* HOISTED */))
const _hoisted_110 = { class: "nge-rs-readout" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-notif-reply-label" }, "Your reply", -1 /* HOISTED */))
const _hoisted_112 = { class: "nge-notif-reply-sent" }
const _hoisted_113 = ["href"]
const _hoisted_114 = ["src"]
const _hoisted_115 = {
  key: 2,
  class: "nge-notif-reply-hint"
}
const _hoisted_116 = {
  key: 3,
  class: "nge-notif-reply-hint"
}
const _hoisted_117 = {
  key: 4,
  class: "nge-notif-reply-hint"
}
const _hoisted_118 = {
  key: 1,
  class: "nge-rs-sending",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-rs-sending-title" }, "Sending your reply", -1 /* HOISTED */))
const _hoisted_120 = { class: "nge-rs-steps" }
const _hoisted_121 = {
  class: "nge-rs-step-mark",
  "aria-hidden": "true"
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "nge-notif-reply-label",
  for: "nge-notif-reply-box"
}, "The team asked for a reply", -1 /* HOISTED */))
const _hoisted_123 = ["disabled"]
const _hoisted_124 = { class: "nge-notif-reply-parts" }
const _hoisted_125 = ["disabled"]
const _hoisted_126 = {
  key: 1,
  class: "nge-notif-reply-part nge-notif-reply-part--on"
}
const _hoisted_127 = ["src"]
const _hoisted_128 = ["disabled"]
const _hoisted_129 = ["aria-pressed", "disabled"]
const _hoisted_130 = ["aria-pressed", "disabled", "title"]
const _hoisted_131 = { class: "nge-notif-reply-row" }
const _hoisted_132 = { class: "nge-notif-reply-hint" }
const _hoisted_133 = ["disabled"]
const _hoisted_134 = {
  key: 0,
  class: "nge-notif-reply-error",
  role: "alert"
}
const _hoisted_135 = {
  key: 3,
  class: "nge-notif-reminder-actions"
}
const _hoisted_136 = {
  key: 4,
  class: "nge-notif-reminder-actions"
}
const _hoisted_137 = ["disabled"]
const _hoisted_138 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createCommentVNode(" With the two admin tabs showing, this marks the tab you are on. "),
            ($setup.showFeedTabs ? $setup.unreadIn($setup.isAdminSide($setup.feedTab) ? $setup.sideNotes($setup.feedTab) : $setup.mainNotes) > 0 : $setup.backend.unreadNotificationCount > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "nge-notif-mark-all",
                  onClick: _cache[0] || (_cache[0] = $event => ($setup.markAllRead()))
                }, _toDisplayString($setup.showFeedTabs && $setup.feedTab === 'triage' ? 'Mark triage read' : $setup.showFeedTabs && ($setup.feedTab === 'admin' || $setup.feedTab === 'access') ? 'Mark admin read' : $setup.showFeedTabs && $setup.feedTab === 'hunt' ? 'Mark reports read' : 'Mark all read'), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Separate from \"mark all read\" on purpose: read state controls the\n             unread pip, this clears the feed. Only hides them for THIS user —\n             the underlying notification rows are untouched. "),
            _createCommentVNode(" Not on the Triage tab: triage is kept and only marked read\n             (Ames 2026-10-07: \"I don't want to delete triage, just mark as\n             read\"). One note can still be removed with its own x. "),
            ($setup.shownNotes.length > 0 && !($setup.showFeedTabs && $setup.feedTab === 'triage'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "nge-notif-delete-all",
                  onClick: _cache[1] || (_cache[1] = $event => ($setup.confirmDeleteAll = true)),
                  title: $setup.showFeedTabs ? 'Delete every notification on this tab; triage is kept (only affects your feed)' : 'Delete all notifications (only affects your feed)'
                }, "Delete all", 8 /* PROPS */, _hoisted_5))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              class: "nge-notif-close",
              onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($setup.emit('hide')), ["stop"]))
            }, "×")
          ])
        ]),
        _createCommentVNode(" Deleting the whole feed is irreversible, so make it a deliberate two\n         step action rather than a single click next to the close button. "),
        ($setup.confirmDeleteAll)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", null, "Delete " + _toDisplayString($setup.shownNotes.length === 1 ? 'this' : 'all ' + $setup.shownNotes.length) + " " + _toDisplayString($setup.showFeedTabs && $setup.feedTab === 'triage' ? 'triage ' : '') + _toDisplayString($setup.shownNotes.length === 1 ? 'notification' : 'notifications') + "?", 1 /* TEXT */),
              _createElementVNode("button", {
                class: "nge-notif-confirm-yes",
                onClick: $setup.doDeleteAll
              }, "Delete"),
              _createElementVNode("button", {
                class: "nge-notif-confirm-no",
                onClick: _cache[3] || (_cache[3] = $event => ($setup.confirmDeleteAll = false))
              }, "Cancel")
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.showFeedTabs)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createCommentVNode(" One feed: everything that is not admin, in one Pyr tab. "),
              (!$setup.splitMain)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass(["nge-notif-tab", { 'nge-notif-tab--on': !$setup.onAdminGroup }]),
                    role: "tab",
                    "aria-selected": !$setup.onAdminGroup,
                    onClick: _cache[4] || (_cache[4] = $event => ($setup.feedTab = 'mine')),
                    title: "Your notifications and Pyr's updates. Settings can sort them into My Pyr and Pyr Updates."
                  }, [
                    _createTextVNode(" Pyr"),
                    ($setup.unreadIn($setup.mainNotes) > 0)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_9, _toDisplayString($setup.unreadIn($setup.mainNotes)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 10 /* CLASS, PROPS */, _hoisted_8))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nge-notif-tab", { 'nge-notif-tab--on': $setup.feedTab === 'mine' }]),
                      role: "tab",
                      "aria-selected": $setup.feedTab === 'mine',
                      onClick: _cache[5] || (_cache[5] = $event => ($setup.feedTab = 'mine')),
                      title: "Sent to you: replies, achievements, your week, your results"
                    }, [
                      _createTextVNode(" My Pyr"),
                      ($setup.unreadIn($setup.mineNotes) > 0)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_11, _toDisplayString($setup.unreadIn($setup.mineNotes)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 10 /* CLASS, PROPS */, _hoisted_10),
                    _createElementVNode("button", {
                      class: _normalizeClass(["nge-notif-tab", { 'nge-notif-tab--on': $setup.feedTab === 'updates' }]),
                      role: "tab",
                      "aria-selected": $setup.feedTab === 'updates',
                      onClick: _cache[6] || (_cache[6] = $event => ($setup.feedTab = 'updates')),
                      title: "Sent to everyone: Today in Pyr, announcements, blog posts, Weekly Champions, competitions"
                    }, [
                      _createTextVNode(" Pyr Updates"),
                      ($setup.unreadIn($setup.updateNotes) > 0)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_13, _toDisplayString($setup.unreadIn($setup.updateNotes)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 10 /* CLASS, PROPS */, _hoisted_12)
                  ], 64 /* STABLE_FRAGMENT */)),
              ($setup.showAdminGroup)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: _normalizeClass(["nge-notif-tab nge-notif-tab--admin", { 'nge-notif-tab--on': $setup.onAdminGroup }]),
                    role: "tab",
                    "aria-selected": $setup.onAdminGroup,
                    onClick: _cache[7] || (_cache[7] = $event => ($setup.onAdminGroup || $setup.openAdminGroup())),
                    title: "Access requests, proofreading tests, players' answers to replies you asked for, triage reports and Hunt reports"
                  }, [
                    _createTextVNode(" Admin"),
                    ($setup.adminGroupUnread > 0)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_15, _toDisplayString($setup.adminGroupUnread), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 10 /* CLASS, PROPS */, _hoisted_14))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Inside the Admin tab, when both kinds have notes: which ones to show. "),
        ($setup.showFeedTabs && $setup.showAdminSwitch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              ($setup.showAccessTab)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass(["nge-notif-subtab", { 'nge-notif-subtab--on': $setup.feedTab === 'access' }]),
                    role: "tab",
                    "aria-selected": $setup.feedTab === 'access',
                    onClick: _cache[8] || (_cache[8] = $event => ($setup.feedTab = 'access')),
                    title: "Access requests: beta, Retina, other datasets, and the daily Access update"
                  }, [
                    _createTextVNode(" Access"),
                    ($setup.unreadIn($setup.accessNotes) > 0)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_18, _toDisplayString($setup.unreadIn($setup.accessNotes)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 10 /* CLASS, PROPS */, _hoisted_17))
                : _createCommentVNode("v-if", true),
              ($setup.showAdminTab)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: _normalizeClass(["nge-notif-subtab", { 'nge-notif-subtab--on': $setup.feedTab === 'admin' }]),
                    role: "tab",
                    "aria-selected": $setup.feedTab === 'admin',
                    onClick: _cache[9] || (_cache[9] = $event => ($setup.feedTab = 'admin')),
                    title: "To do board tags, players' answers to replies you asked for, and proofreading tests"
                  }, [
                    _createTextVNode(" To do and replies"),
                    ($setup.unreadIn($setup.adminNotes) > 0)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_20, _toDisplayString($setup.unreadIn($setup.adminNotes)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 10 /* CLASS, PROPS */, _hoisted_19))
                : _createCommentVNode("v-if", true),
              ($setup.showTriageTab)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: _normalizeClass(["nge-notif-subtab nge-notif-subtab--triage", { 'nge-notif-subtab--on': $setup.feedTab === 'triage' }]),
                    role: "tab",
                    "aria-selected": $setup.feedTab === 'triage',
                    onClick: _cache[10] || (_cache[10] = $event => ($setup.feedTab = 'triage')),
                    title: "Triage: bug reports and ideas from players, and what the triage loop did with them"
                  }, [
                    _createTextVNode(" Triage"),
                    ($setup.unreadIn($setup.triageNotes) > 0)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_22, _toDisplayString($setup.unreadIn($setup.triageNotes)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 10 /* CLASS, PROPS */, _hoisted_21))
                : _createCommentVNode("v-if", true),
              ($setup.showHuntTab)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: _normalizeClass(["nge-notif-subtab nge-notif-subtab--hunt", { 'nge-notif-subtab--on': $setup.feedTab === 'hunt' }]),
                    role: "tab",
                    "aria-selected": $setup.feedTab === 'hunt',
                    onClick: _cache[11] || (_cache[11] = $event => ($setup.feedTab = 'hunt')),
                    title: "Hunt reports: problems hunters say the answers missed. Click one to go through them, the oldest first"
                  }, [
                    _createTextVNode(" Hunt reports"),
                    ($setup.unreadIn($setup.huntNotes) > 0)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_24, _toDisplayString($setup.unreadIn($setup.huntNotes)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 10 /* CLASS, PROPS */, _hoisted_23))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.shownNotes.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.shownNotes, (notif) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: notif.id,
                  class: _normalizeClass(["nge-notif-card", { 'nge-notif-card--unread': !$setup.isRead(notif.id), 'nge-notif-card--triage': (notif.title || '').startsWith('🗂'), 'nge-notif-card--fixed': (notif.title || '').startsWith('🎉'), 'nge-notif-card--streak': (notif.title || '').startsWith('🔥'), 'nge-notif-card--thanks': (notif.title || '').startsWith('💙'), 'nge-notif-card--recap': (notif.title || '').startsWith('✨') }]),
                  onClick: $event => ($setup.openDetail(notif))
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("img", {
                      src: notif.thumbnail_url || notif.image_url || $setup.pyrIcon,
                      class: _normalizeClass(["nge-notif-thumb-sm", { 'nge-notif-thumb-fallback': !notif.thumbnail_url && !notif.image_url }])
                    }, null, 10 /* CLASS, PROPS */, _hoisted_28),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        (!$setup.isRead(notif.id))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_32, _toDisplayString($setup.cleanCopy(notif.title)), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_33, _toDisplayString($setup.relativeTime(notif.send_at)), 1 /* TEXT */),
                        _createCommentVNode(" No admin delete here (Ames 2026-10-06): one stray click in the\n                   bell removed a broadcast for every player, for good. Deleting a\n                   notification for everyone lives in the Admin Hub only. The x\n                   below hides it from your own feed and nobody else's. "),
                        _createElementVNode("button", {
                          class: "nge-notif-dismiss",
                          onClick: _withModifiers($event => ($setup.backend.dismissNotification(notif.id)), ["stop"]),
                          title: "Dismiss"
                        }, "×", 8 /* PROPS */, _hoisted_34)
                      ]),
                      _createElementVNode("div", _hoisted_35, _toDisplayString($setup.plainText($setup.cleanCopy(notif.body))), 1 /* TEXT */),
                      ($setup.asksReply(notif) && !notif.replied_at)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Reply requested"))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ], 10 /* CLASS, PROPS */, _hoisted_26))
              }), 128 /* KEYED_FRAGMENT */)),
              ($setup.backend.notificationsHaveMore)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "nge-notif-more",
                    disabled: $setup.loadingMore,
                    onClick: _withModifiers($setup.showMore, ["stop"])
                  }, _toDisplayString($setup.loadingMore ? 'Loading\u2026' : 'Show more'), 9 /* TEXT, PROPS */, _hoisted_37))
                : _createCommentVNode("v-if", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createTextVNode(" No notifications yet. "),
              ($setup.backend.notificationsHaveMore)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "nge-notif-more",
                    disabled: $setup.loadingMore,
                    onClick: _withModifiers($setup.showMore, ["stop"])
                  }, _toDisplayString($setup.loadingMore ? 'Loading\u2026' : 'Show more'), 9 /* TEXT, PROPS */, _hoisted_39))
                : _createCommentVNode("v-if", true)
            ])),
        _createCommentVNode(" Drag to make the window taller or shorter (Ames 2026-10-20); a\n         double click gives back its usual height. "),
        _createElementVNode("div", {
          class: "nge-notif-grip",
          title: "Drag to make this window taller or shorter. Double click for its usual size.",
          onPointerdown: $setup.startResize,
          onDblclick: _withModifiers($setup.resetHeight, ["stop"])
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_40)
      ], 512 /* NEED_PATCH */), [
        [_vShow, $props.visible]
      ])
    ])),
    _createCommentVNode(" ═══ Detail overlay (separate Teleport so it's not clipped by panel) ═══ "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "nge-notif-detail" }, {
        default: _withCtx(() => [
          ($setup.openNotif)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref: "detailBackdrop",
                class: _normalizeClass(["nge-notif-detail-backdrop", { 'nge-notif-detail-backdrop--preview': $setup.openNotif.preview }]),
                onClick: _withModifiers($setup.closeDetail, ["self"])
              }, [
                _createCommentVNode(" Champions: confetti falls behind the card (Ames 2026-10-26). "),
                ($setup.champions)
                  ? (_openBlock(), _createBlock($setup["ConfettiCelebration"], {
                      key: 0,
                      ref: "champConfetti",
                      inline: ""
                    }, null, 512 /* NEED_PATCH */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["nge-notif-detail", { 'nge-notif-detail--champions': $setup.champions, 'nge-notif-detail--monthly': $setup.champGrand, 'nge-notif-detail--yearly': $setup.champions?.kind === 'Pyr Year Champions', 'nge-notif-detail--picture': !!($setup.openNotif.image_url || $setup.openNotif.thumbnail_url), 'nge-notif-detail--wide-picture': $setup.pictureWide && !$setup.longRead }]),
                  role: "dialog",
                  "aria-modal": "true",
                  "aria-label": $setup.cleanCopy($setup.openNotif.title)
                }, [
                  _createCommentVNode(" Instrument chrome: four corner brackets that settle in once, and a\n               scan band that passes once on open. Never looping. "),
                  _hoisted_43,
                  _hoisted_44,
                  _hoisted_45,
                  _hoisted_46,
                  _hoisted_47,
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("span", _hoisted_49, [
                      _hoisted_50,
                      _createElementVNode("span", _hoisted_51, _toDisplayString($setup.champions ? 'Broadcast' : 'Notification'), 1 /* TEXT */),
                      _hoisted_52,
                      _createElementVNode("span", _hoisted_53, _toDisplayString($setup.openNotif.preview && !$setup.openNotif.viewing ? 'Preview, not sent' : $setup.relativeTime($setup.openNotif.send_at)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("button", {
                      class: "nge-notif-detail-close",
                      onClick: $setup.closeDetail,
                      "aria-label": "Close"
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["nge-notif-detail-layout", { 'nge-notif-detail-layout--has-image': ($setup.openNotif.image_url || $setup.openNotif.thumbnail_url) && !$setup.pictureOnly, 'nge-notif-detail-layout--picture-only': $setup.pictureOnly }])
                    }, [
                      ($setup.openNotif.image_url || $setup.openNotif.thumbnail_url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _createElementVNode("img", {
                              src: $setup.openNotif.image_url || $setup.openNotif.thumbnail_url,
                              class: "nge-notif-detail-img",
                              onLoad: $setup.onPictureLoad,
                              onClick: _cache[12] || (_cache[12] = $event => ($setup.lightboxUrl = $setup.openNotif.image_url || $setup.openNotif.thumbnail_url))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_56),
                            ($setup.digestStats)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                  _hoisted_58,
                                  _createElementVNode("div", _hoisted_59, [
                                    _createElementVNode("span", _hoisted_60, _toDisplayString($setup.digestStats.edits), 1 /* TEXT */),
                                    _createElementVNode("span", _hoisted_61, _toDisplayString($setup.digestStats.editsOne ? 'edit' : 'edits'), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("span", _hoisted_63, _toDisplayString($setup.digestStats.cells), 1 /* TEXT */),
                                    _createElementVNode("span", _hoisted_64, _toDisplayString($setup.digestStats.cellsOne ? 'cell completed' : 'cells completed'), 1 /* TEXT */)
                                  ])
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_65, [
                        _createCommentVNode(" Weekly Champions: parsed into a podium. parseChampions()\n                     returns null on anything unexpected, which lands in the\n                     ordinary rendering below. "),
                        ($setup.champions)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("header", _hoisted_66, [
                                _createCommentVNode(" The trophy: Ames's art when it is in (CHAMP_TROPHY), the cup until then. "),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["nge-champs-emblem", { 'nge-champs-emblem--art': $setup.champTrophy }]),
                                  "aria-hidden": "true"
                                }, [
                                  ($setup.champTrophy)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: $setup.champTrophy,
                                        alt: "",
                                        class: "nge-champs-trophy"
                                      }, null, 8 /* PROPS */, _hoisted_67))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_68, "🏆"))
                                ], 2 /* CLASS */),
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("div", _hoisted_70, _toDisplayString($setup.champions.kind), 1 /* TEXT */),
                                  _createElementVNode("h2", _hoisted_71, _toDisplayString($setup.champions.range || `This ${$setup.champSpan}`), 1 /* TEXT */),
                                  ($setup.champYearDates)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString($setup.champYearDates), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ]),
                              _createCommentVNode(" One line for every Champions card, old and new (Ames 2026-10-26: the date\n                       above already says which week or month). "),
                              _createElementVNode("p", _hoisted_73, _toDisplayString($setup.champCheer), 1 /* TEXT */),
                              _createCommentVNode(" Wide screens: the categories sit side by side (Ames 2026-10-05). "),
                              _createElementVNode("div", _hoisted_74, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.champions.sections, (section, si) => {
                                  return (_openBlock(), _createElementBlock("section", {
                                    key: si + '-' + section.label,
                                    class: "nge-champs-section"
                                  }, [
                                    _createElementVNode("div", _hoisted_75, [
                                      _createElementVNode("span", _hoisted_76, _toDisplayString(section.label), 1 /* TEXT */),
                                      _hoisted_77,
                                      (section.entries.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(section.entries.length) + " ranked", 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    (section.entries.length === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                          _hoisted_80,
                                          _createElementVNode("div", _hoisted_81, [
                                            _createElementVNode("div", _hoisted_82, "No activity this " + _toDisplayString($setup.champSpan), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_83, "The podium is open. Next " + _toDisplayString($setup.champSpan) + " it could be yours.", 1 /* TEXT */)
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createElementVNode("div", _hoisted_84, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.podiumOrder(section.entries), (entry) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: entry.rank + '-' + entry.name,
                                                class: _normalizeClass(["nge-champs-step", 'nge-champs-step--' + $setup.champTier(entry.rank)])
                                              }, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["nge-champs-card", { 'nge-champs-link': $setup.championId(entry.name) }]),
                                                  role: $setup.championId(entry.name) ? 'button' : undefined,
                                                  tabindex: $setup.championId(entry.name) ? 0 : undefined,
                                                  title: $setup.championId(entry.name) ? `Open ${entry.name}'s profile` : undefined,
                                                  onClick: $event => ($setup.openChampion(entry.name)),
                                                  onKeydown: _withKeys($event => ($setup.openChampion(entry.name)), ["enter"])
                                                }, [
                                                  ($setup.champGrand && entry.rank <= 3)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: $setup.monthTrophy(section.label, entry.rank),
                                                        alt: "",
                                                        class: "nge-champs-medal nge-champs-cupimg"
                                                      }, null, 8 /* PROPS */, _hoisted_86))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_87, _toDisplayString($setup.champMedal(entry.rank)), 1 /* TEXT */)),
                                                  _createElementVNode("span", _hoisted_88, _toDisplayString(entry.name), 1 /* TEXT */),
                                                  _createElementVNode("span", _hoisted_89, _toDisplayString(entry.count), 1 /* TEXT */),
                                                  _createElementVNode("span", _hoisted_90, _toDisplayString(entry.unit), 1 /* TEXT */)
                                                ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_85),
                                                _createElementVNode("div", _hoisted_91, [
                                                  _createElementVNode("span", null, _toDisplayString($setup.padRank(entry.rank)), 1 /* TEXT */)
                                                ])
                                              ], 2 /* CLASS */))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ]),
                                          (section.entries.length > 3)
                                            ? (_openBlock(), _createElementBlock("ol", _hoisted_92, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.entries.slice(3), (entry, ei) => {
                                                  return (_openBlock(), _createElementBlock("li", {
                                                    key: ei + '-' + entry.name,
                                                    class: _normalizeClass(["nge-champs-row", { 'nge-champs-link': $setup.championId(entry.name) }]),
                                                    role: $setup.championId(entry.name) ? 'button' : undefined,
                                                    tabindex: $setup.championId(entry.name) ? 0 : undefined,
                                                    title: $setup.championId(entry.name) ? `Open ${entry.name}'s profile` : undefined,
                                                    onClick: $event => ($setup.openChampion(entry.name)),
                                                    onKeydown: _withKeys($event => ($setup.openChampion(entry.name)), ["enter"])
                                                  }, [
                                                    _createElementVNode("span", _hoisted_94, _toDisplayString($setup.padRank(entry.rank)), 1 /* TEXT */),
                                                    _createElementVNode("span", _hoisted_95, _toDisplayString(entry.name), 1 /* TEXT */),
                                                    _createElementVNode("span", _hoisted_96, _toDisplayString(entry.count), 1 /* TEXT */),
                                                    _createElementVNode("span", _hoisted_97, _toDisplayString(entry.unit), 1 /* TEXT */)
                                                  ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_93))
                                                }), 128 /* KEYED_FRAGMENT */))
                                              ]))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              ($setup.champions.outro)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_98, _toDisplayString($setup.champions.outro), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("h2", _hoisted_99, _toDisplayString($setup.cleanCopy($setup.openNotif.title)), 1 /* TEXT */),
                              _hoisted_100,
                              _createElementVNode("div", {
                                class: "nge-notif-detail-body",
                                innerHTML: $setup.withVideoEmbeds($setup.renderMarkdown($setup.cleanCopy($setup.detailBody))),
                                onClick: $setup.onDetailBodyClick
                              }, null, 8 /* PROPS */, _hoisted_101),
                              ($setup.helpSolvedNote)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_102, _toDisplayString($setup.helpSolvedNote), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */)),
                        _createCommentVNode(" A reply the team asked for: one per request, with what a report carries. "),
                        ($setup.replyAsked)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                              ($setup.openNotif.replied_at)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createCommentVNode(" Just sent: the bug report's arrival, smaller. "),
                                    ($setup.replyJustSent)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                          _hoisted_105,
                                          _hoisted_106,
                                          _createElementVNode("div", _hoisted_107, [
                                            _createVNode($setup["GrowingNeuron"], {
                                              arrived: "",
                                              seed: $setup.replySeed
                                            }, null, 8 /* PROPS */, ["seed"])
                                          ]),
                                          _hoisted_108,
                                          _hoisted_109,
                                          _createElementVNode("dl", _hoisted_110, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.replySentWith, (x, i) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: x.k,
                                                class: "nge-rs-cell",
                                                style: _normalizeStyle({ '--i': i })
                                              }, [
                                                _createElementVNode("dt", null, _toDisplayString(x.k), 1 /* TEXT */),
                                                _createElementVNode("dd", null, _toDisplayString(x.v), 1 /* TEXT */)
                                              ], 4 /* STYLE */))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ])
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    _hoisted_111,
                                    _createElementVNode("div", _hoisted_112, _toDisplayString($setup.openNotif.reply_text), 1 /* TEXT */),
                                    ($setup.openNotif.reply_screenshot_url)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          href: $setup.openNotif.reply_screenshot_url,
                                          target: "_blank",
                                          rel: "noopener",
                                          class: "nge-notif-reply-shot",
                                          title: "Open the full screenshot"
                                        }, [
                                          _createElementVNode("img", {
                                            src: $setup.openNotif.reply_screenshot_url,
                                            alt: "The screenshot you sent"
                                          }, null, 8 /* PROPS */, _hoisted_114)
                                        ], 8 /* PROPS */, _hoisted_113))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.openNotif.reply_view_url)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_115, "Your view was sent with it."))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.replyNote)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_116, _toDisplayString($setup.replyNote), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    (!$setup.replyJustSent)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, _toDisplayString('Sent ' + $setup.relativeTime($setup.openNotif.replied_at) + '.'), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : ($setup.replySending)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                      _createVNode($setup["GrowingNeuron"], {
                                        stage: $setup.replyStepsDone,
                                        stages: $setup.replySteps.length,
                                        seed: $setup.replySeed
                                      }, null, 8 /* PROPS */, ["stage", "stages", "seed"]),
                                      _hoisted_119,
                                      _createElementVNode("ul", _hoisted_120, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.replySteps, (st) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: st.key,
                                            class: _normalizeClass(["nge-rs-step", `nge-rs-step--${$setup.replyStepState(st.key)}`])
                                          }, [
                                            _createElementVNode("span", _hoisted_121, _toDisplayString($setup.replyStepState(st.key) === 'done' ? '✓' : ''), 1 /* TEXT */),
                                            _createElementVNode("span", null, _toDisplayString(st.label), 1 /* TEXT */)
                                          ], 2 /* CLASS */))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _hoisted_122,
                                      _withDirectives(_createElementVNode("textarea", {
                                        id: "nge-notif-reply-box",
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($setup.replyDraft) = $event)),
                                        class: "nge-notif-reply-box",
                                        rows: "3",
                                        maxlength: $setup.REPLY_MAX,
                                        disabled: $setup.replySending,
                                        placeholder: "Write your reply here",
                                        onKeydown: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
                                        onKeyup: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"])),
                                        onKeypress: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_123), [
                                        [_vModelText, $setup.replyDraft]
                                      ]),
                                      _createCommentVNode(" What goes with it, as on a report. "),
                                      _createElementVNode("div", _hoisted_124, [
                                        (!$setup.replyShot)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              type: "button",
                                              class: "nge-notif-reply-part",
                                              disabled: $setup.replySending,
                                              onClick: _cache[17] || (_cache[17] = $event => ($setup.showReplyShot = true)),
                                              title: "Take a screenshot of what you see now. You can draw on it before it is attached."
                                            }, "📷 Add a screenshot", 8 /* PROPS */, _hoisted_125))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_126, [
                                              _createElementVNode("img", {
                                                src: $setup.replyShot,
                                                alt: "Screenshot attached"
                                              }, null, 8 /* PROPS */, _hoisted_127),
                                              _createTextVNode(" Screenshot attached "),
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "nge-notif-reply-x",
                                                disabled: $setup.replySending,
                                                "aria-label": "Remove the screenshot",
                                                onClick: _cache[18] || (_cache[18] = $event => ($setup.replyShot = ''))
                                              }, "×", 8 /* PROPS */, _hoisted_128)
                                            ])),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: _normalizeClass(["nge-notif-reply-part", { 'nge-notif-reply-part--on': $setup.replyAttachView }]),
                                          "aria-pressed": $setup.replyAttachView ? 'true' : 'false',
                                          disabled: $setup.replySending,
                                          title: "Sends a link to exactly what you are looking at, so the team can open it.",
                                          onClick: _cache[19] || (_cache[19] = $event => ($setup.replyAttachView = !$setup.replyAttachView))
                                        }, _toDisplayString($setup.replyAttachView ? '✓' : '+') + " My current view", 11 /* TEXT, CLASS, PROPS */, _hoisted_129),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: _normalizeClass(["nge-notif-reply-part", { 'nge-notif-reply-part--on': $setup.replyAttachConsole && $setup.replyConsoleCount > 0 }]),
                                          "aria-pressed": $setup.replyAttachConsole && $setup.replyConsoleCount > 0 ? 'true' : 'false',
                                          disabled: $setup.replySending || !$setup.replyConsoleCount,
                                          title: $setup.replyConsoleCount ? 'Sends the recent warnings and errors from this page. Only the team can read them.' : 'There are no recent warnings or errors to send.',
                                          onClick: _cache[20] || (_cache[20] = $event => ($setup.replyAttachConsole = !$setup.replyAttachConsole))
                                        }, _toDisplayString($setup.replyAttachConsole && $setup.replyConsoleCount ? '✓' : '+') + " Console messages (" + _toDisplayString($setup.replyConsoleCount) + ")", 11 /* TEXT, CLASS, PROPS */, _hoisted_130)
                                      ]),
                                      _createElementVNode("div", _hoisted_131, [
                                        _createElementVNode("span", _hoisted_132, _toDisplayString($setup.REPLY_MAX - $setup.replyDraft.length) + " characters left.", 1 /* TEXT */),
                                        _createElementVNode("button", {
                                          class: "nge-notif-reply-send",
                                          disabled: $setup.replySending || !$setup.replyDraft.trim(),
                                          onClick: $setup.sendReply
                                        }, _toDisplayString($setup.replySending ? 'Sending…' : 'Send reply'), 9 /* TEXT, PROPS */, _hoisted_133)
                                      ]),
                                      ($setup.replyError)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_134, _toDisplayString($setup.replyError), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true),
                        ($setup.triageReportId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                              _createElementVNode("button", {
                                class: "nge-notif-open-help",
                                onClick: $setup.openTriageReport
                              }, "Open this report in triage ↗")
                            ]))
                          : _createCommentVNode("v-if", true),
                        ($setup.reminderId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                              _createElementVNode("button", {
                                class: "nge-notif-open-help nge-notif-solve",
                                disabled: !!$setup.reminderReq?.resolved || $setup.helpSolvedNote.startsWith('Marked solved'),
                                onClick: _cache[21] || (_cache[21] = $event => ($setup.markReminderSolved($setup.reminderId)))
                              }, _toDisplayString($setup.reminderReq?.resolved || $setup.helpSolvedNote.startsWith('Marked solved') ? 'Solved ✓' : '✓ Mark solved'), 9 /* TEXT, PROPS */, _hoisted_137),
                              ($setup.reminderView.url)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "nge-notif-open-help",
                                    onClick: $setup.openReminderView
                                  }, "↗ " + _toDisplayString($setup.reminderView.label), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("button", {
                                class: "nge-notif-open-help",
                                onClick: $setup.openHelpTab
                              }, "Open in Help tab →")
                            ]))
                          : _createCommentVNode("v-if", true),
                        ($setup.isHelpNotification($setup.openNotif) && !$setup.reminderId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 5,
                              class: "nge-notif-open-help",
                              onClick: $setup.openHelpTab
                            }, "Open in Help tab →"))
                          : _createCommentVNode("v-if", true)
                      ])
                    ], 2 /* CLASS */)
                  ])
                ], 10 /* CLASS, PROPS */, _hoisted_42)
              ], 10 /* CLASS, PROPS */, _hoisted_41))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" Lightbox for full-size images "),
      ($setup.lightboxUrl)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "nge-notif-lightbox",
            onClick: _cache[22] || (_cache[22] = $event => ($setup.lightboxUrl = null))
          }, [
            _createElementVNode("img", {
              src: $setup.lightboxUrl,
              class: "nge-notif-lightbox-img"
            }, null, 8 /* PROPS */, _hoisted_138)
          ]))
        : _createCommentVNode("v-if", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createCommentVNode(" The notification steps out of the way for the capture, so the picture\n         is of the game and not of this message. "),
      _createVNode($setup["ScreenshotDialog"], {
        show: $setup.showReplyShot,
        mode: "attach",
        "hide-opener": ".nge-notif-detail, .nge-notif-panel",
        onClose: _cache[23] || (_cache[23] = $event => ($setup.showReplyShot = false)),
        onAttached: $setup.onReplyShot
      }, null, 8 /* PROPS */, ["show"])
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}